/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 *
 * The interface language loads first, so every module of the app can translate
 * as it loads (see src/_metronic/i18n/translate.js). A language that fails to
 * load leaves the platform in English rather than not starting it.
 */
import { loadTranslations } from "./_metronic/i18n/loadTranslations";

loadTranslations()
   .catch((error) => console.error(error))
   .then(() => import("./startApp"));
